import type {
  CreateDutyResponseInput,
  DutyResponse,
  UpdateDutyResponseInput,
} from "dutyon-server/types";
import { httpClient } from "./httpClient";

export const findAllDutyResponses = async (): Promise<DutyResponse[]> => {
  const response = await httpClient.get<DutyResponse[]>("/duty-responses");
  return response.data;
};

export const getMyTeamDutyResponses = async (teamId?: string): Promise<DutyResponse[]> => {
  const response = await httpClient.get<DutyResponse[]>("/duty-responses/my-team", {
    params: { teamId },
  });
  return response.data;
};

export const findOneDutyResponse = async (id: string): Promise<DutyResponse | null> => {
  const response = await httpClient.get<DutyResponse | null>(`/duty-responses/${id}`);
  return response.data;
};

export const createDutyResponse = async (data: CreateDutyResponseInput): Promise<DutyResponse> => {
  const response = await httpClient.post<DutyResponse>("/duty-responses", data);
  return response.data;
};

export const updateDutyResponse = async (
  id: string,
  data: UpdateDutyResponseInput,
): Promise<DutyResponse> => {
  const response = await httpClient.put<DutyResponse>(`/duty-responses/${id}`, data);
  return response.data;
};

export const removeDutyResponse = async (id: string): Promise<DutyResponse> => {
  const response = await httpClient.delete<DutyResponse>(`/duty-responses/${id}`);
  return response.data;
};

export const getMyTeamDutySchedules = async (): Promise<DutyResponse[]> => {
  const response = await httpClient.get<DutyResponse[]>("/duty-responses/my-team");
  return response.data;
};
